import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Achievement = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="py-12 font-titleFont flex gap-20"
    >
      <div>
        <div className="py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2023 - 2025</p>
          <h2 className="text-4xl font-bold">Company Experience</h2>
        </div>
        <div className="mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Automation Specialist"
            subTitle="Meddey Technologies (2023 – Present)"
            result="Success"
            des="Developed automation tools for order tracking, remittance mapping, and bulk data sync. Reduced manual operations and improved team efficiency across departments."
          />
          <ResumeCard
            title="Web & SEO Developer"
            subTitle="Medansh.in Project (2022 – 2023)"
            result="Success"
            des="Built and optimized eCommerce collection pages with improved descriptions, alt text, SEO slugs, and backlinks — leading to increased traffic and better search rankings."
          />
          <ResumeCard
            title="Website Developer"
            subTitle="Golden Age Media & Abhay Gifts (2021 – 2022)"
            result="Success"
            des="Designed and developed websites for Golden Age Media and Abhay Gifts, enhancing their online presence and user experience. Implemented responsive designs and optimized performance."
          />
        </div>
      </div>
      <div>
        <div className="py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2023 -2025</p>
          <h2 className="text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Full-Stack Developer"
            subTitle="Freelance & Personal Projects"
            result="Success"
            des="Built end-to-end applications using MERN stack, automated backend processes, integrated APIs, and created admin dashboards to support operations."
          />
          <ResumeCard
            title="Automation Engineer"
            subTitle="Book Publishing"
            result="Success"
            des="Automated diacritics correction in spiritual textbooks using AI, improving publishing speed and accuracy with minimal manual proofreading."
          />
          <ResumeCard
            title="Google Ads Automation"
            subTitle="Marketing"
            result="Success"
            des="Created a Python-based automation system to generate and manage Google Ads campaigns by reading inputs from Sheets and simulating UI interactions."
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Achievement;
